/* eslint-disable react/no-this-in-sfc */
import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
const dayjs = require('dayjs');

const LineGraph = ({ seriesData }) => {
  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={{
        chart: {
          height: 600,
        },
        title: {
          text: 'YoY % Changes in Revenue, Jobs, and Ticket Size by Month',
        },
        xAxis: {
          title: {
            text: undefined,
            y: 15,
          },
          type: 'datetime',
        },
        yAxis: {
          title: {
            text: undefined,
          },
          labels: {
            formatter: (x) => '',
          },
        },
        legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'top',
        },
        plotOptions: {
          line: {
            dataLabels: {
              formatter: function () {
                return `${this.y}%`;
              },
              enabled: true,
              y: -10,
            },
          },
        },
        tooltip: {
          formatter: function () {
            return `Month: ${dayjs(this.x).format('MMMM YYYY')}<br />${this.series.name}: ${
              this.y
            }%`;
          },
        },
        series: seriesData,
      }}
    />
  );
};

export default LineGraph;
